<template>

  <div class="active-basic">
    <div class="common-form">基本信息</div>

    


    
    <el-form-item label="圈子标题" prop="title" >
      <div>{{form.title  }}</div>
    </el-form-item>

    <el-form-item label="圈子简介" prop="title">
      <div>{{form.subtitle  }}</div>
    </el-form-item>

  
  <!-- 全分类选择 -->
  <el-form-item label="圈子分类" prop="name" >
      <div>{{ form.categorya.name }}</div>
      <el-button @click="chooseCategory" icon="el-icon-plus">选择分类</el-button>
    </el-form-item>


    <el-form-item label="是否免费">
      <template >
        <el-radio-group v-model="form.is_free" >
          <el-radio :label="0">免费</el-radio>
          <el-radio :label="1">付费</el-radio>
        </el-radio-group>
      </template>

    </el-form-item>
  

    <el-form-item label="价格" prop="price" v-if="form.is_free == 1">
      <div>{{form.price  }}</div>
    </el-form-item>

    
    <el-form-item label="是否推荐">
      <template >
        <el-radio-group v-model="form.is_commond">
          <el-radio :label="1">推荐</el-radio>
          <el-radio :label="0">不推荐</el-radio>
        
        </el-radio-group>
      </template>

    </el-form-item>


      




    <el-form-item label="虚拟内容数量"  prop="virtual_content">
      <div class="max-w460">
        <el-input v-model="form.virtual_content" type="number"></el-input>
      </div>
    </el-form-item>

    <el-form-item label="虚拟成员数量"  prop="virtual_member">
      <div class="max-w460">
        <el-input v-model="form.virtual_member" type="number"></el-input>
      </div>
    </el-form-item>


    <div class="common-form">产品圈子信息</div>


    <el-form-item label="是否为产品圈子">
      <template >
        <el-radio-group v-model="form.is_product">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">不是</el-radio>
        
        </el-radio-group>
      </template>

    </el-form-item>

    <el-form-item label="Bannar：" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" >
          <transition-group>
            <div v-for="(item, index) in form.bannar" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" 
                @click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('bannar')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>


    <el-form-item label="产品实拍" prop="model.os_design_sketch">
      <div class="draggable-list">
        <draggable class="wrapper">
          <transition-group>
            <div  v-for="(item, index) in form.rs" :key="item.file_path">
              <div class="item" style="width: 300px;height: 200px;">
                <video controls :src="item.file_path" width="300" height="200" alt="file_path" ></video>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'video')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openVideoUpload(1,'setting_video')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item> 


    <el-form-item label="产品详情">
      <template >
        <el-button size="small" type="primary" @click="bc_detail_click(form)" >补充产品详情</el-button>
      </template>

    </el-form-item>  


    <el-form-item label="关于售后">
      <template >
        <el-button size="small" type="primary" @click="bc_sales_click(form)">补充关于售后</el-button>
      </template>

    </el-form-item>  


    <div class="common-form">监控相关</div>

            
    <el-form-item label="uniacid">
      <template >
        <div class="max-w460">
        <el-input v-model="form.uniacid" type="number"></el-input>
      </div>
      </template>

    </el-form-item>  


    
    <el-form-item label="监控名称">
      <template >
        <div class="max-w460">
        <el-input v-model="form.mname" type="text"></el-input>
      </div>
      </template>

    </el-form-item>  

        
    <el-form-item label="序列号">
      <template >
        <div class="max-w460">
        <el-input v-model="form.snumber" type="text"></el-input>
      </div>
      </template>

    </el-form-item>  

        
    <el-form-item label="通道">
      <template >
        <div class="max-w460">
        <el-input v-model="form.passageway" type="number"></el-input>
      </div>
      </template>

    </el-form-item>  


    <el-form-item label="设置监控跳转的图片">
      <template >
        <div class="max-w460">
        <el-input v-model="form.bcbannar" type="number"></el-input>
      </div>
      <div>请输入数字，数字代表bannar的位置，从0开始，比如6张bannar图，第一张请填写0，最后一张请填写5。</div>
      </template>

    </el-form-item>  





    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>

    <Categoryas :isproduct="iscategorya" code="圈子分类" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas>

    <Upload v-if="isVideoUpload" :config="{ total: 9 }" :isupload="isVideoUpload" @returnImgs="returnvideoFunc">上传视频
    </Upload>

    <Bd :open_add="open_bd"  :obj="obj"  v-if="open_bd"   @close="closeBd"></Bd>
    <Bs :open_add="open_bs" :obj="obj"  v-if="open_bs"   @close="closeBs"></Bs>
   
  </div>
</template>

<script>

import Uediter from '@/components/UE1.vue';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Bd from './bc_detail.vue';
import Bs from './bc_sales.vue';
export default {
  components: {
    Uediter,
    Categoryas,
    Upload,
    Bd,
    Bs,
    draggable,
    

  },
  data() {
    /*验证图片是否上传*/
    const validatorImages = (rule, value, callback) => {
      if (value < 1) {
        return callback(new Error('请上传房源图'));
      } else {
        callback();
      }
    };
    return {
      /*如果没有后面的-8.64e7就是不可以选择今天的*/
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      isupload:false,
      /*图片是否上传了*/
      rulesImage: [{ validator: validatorImages, required: true, message: '请上传房源广告图片', trigger: 'change' }],
      ueditor: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 300
        },
      },
      ueditor2: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight:200
        },
      },
      ueditor3: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight:200
        },
      },
      ueditor4: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight:200
        },
      },
      ue1:"ue1",
      ue2:"ue2",
      ue3:"ue3",
      ue4:"ue4",
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      isVideoUpload: false,
      cindex:0,
      obj:{},
      open_bd:false,
      open_bs:false,

    };
  },
  props: ['form','editType'],
  methods: {
    bc_sales_click(item){
      this.open_bs  = true;
      this.obj = item
    },
    bc_detail_click(item){
      this.open_bd  = true;
      this.obj = item
    },
    closeBd(e){
    
      this.form.detail.html =e.detail.html;
      this.open_bd  = false;
     
    },
    closeBs(e){
      this.form.as.html =e.as.html;
      this.open_bs  = false;
     
    },

    chooseCategory(index){
      this.cindex = index;
      this.iscategorya = true;
    },

    closeDialogFunc(e) {
      let self = this;
      self.iscategorya = false;

      if (e.type === 'success') {
        self.form.categorya = {
            name: e.params[0].name,
            categorya_id: e.params[0].categorya_id,
            image: e.params[0].image,
          }
          self.form.categorya_id =  e.params[0].categorya_id;
      }
    },
        /*删除商品图片*/
        deleteImg(index,code) {
      if(code == 'video'){
        this.form.rs.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
    },
      /*上传商品图片*/
      returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["jpg", "png",'jpeg'];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        let bannar = this.form.bannar;
      
        e.forEach((element) => {
          bannar.push(element);
        })

        this.form.bannar = bannar;
        this.$set(this.form, "bannar", bannar);
      }
      this.isProductUpload = false;
    },

    openVideoUpload:function (code) {
      this.isVideoUpload = true;
    },

    returnvideoFunc(e){
      if (e != null) {
        let imgExpt = ["mp4", "mp3"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("视频类型有误,请选择正确的视频格式");
          return false;
        }
        let rs = this.form.rs;
  
        e.forEach((element) => {
          rs.push(element);
        })
 
        this.form.rs = rs;
        this.$set(this.form, "rs", rs);
      }
      this.isVideoUpload = false
    },
  }
};
</script>

<style lang="scss">
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/part/Basic.vue